import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { CustomMutationArgs } from '../types';
import { useFetcher } from './useFetcher';

export const useCustomMutation = (args: CustomMutationArgs): UseMutationResult<any, any, any, any> => {
  return useMutation({
    mutationFn: useFetcher(args.query),
    ...args.options,
  });
};
